import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Images from '../../Images';
import { useNavigate } from 'react-router-dom';

const HeroSection = () => {
  const HeroImages = [Images.category_img, Images.category_img_two, Images.category_img_three];
  const [currentImage, setCurrentImage] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prevImage) => (prevImage + 1) % HeroImages.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [HeroImages.length]);

  return (
    <section className="relative min-h-[70vh] bg-[#FCB19C59] overflow-hidden lg:rounded-br-[15rem] lg:rounded-bl-[15rem]">
      <div className="px-4 py-8 mx-auto max-w-7xl sm:px-6 lg:px-8 lg:py-20">
        <div className="flex flex-col-reverse items-center justify-between gap-8 lg:flex-row lg:gap-12">
          <div className="flex-1 max-w-xl text-center lg:text-left">
            <h1 className="mb-4 text-3xl font-bold leading-tight text-gray-900 lg:text-5xl lg:mb-6">
              Your Go-To Platform To Promote Your Discounted Deals & Offers.
            </h1>
            <p className="mb-6 text-base leading-relaxed text-gray-600 lg:text-lg lg:mb-8">
              Showcase, manage, and optimize all your deals and discounts, reaching a targeted audience of customers ready to engage and redeem your offers.
            </p>
            <button onClick={()=>navigate("/signin")} className="px-6 py-3 text-base font-medium text-white transition-colors duration-300 bg-red-400 rounded-full lg:px-8 lg:py-4 lg:text-lg hover:bg-red-500">
              Get Started
            </button>
          </div>

          <div className="flex-1 w-full lg:w-auto">
            <div className="relative h-[300px] lg:h-[500px] w-full">
              <AnimatePresence mode="wait">
                <motion.img
                  key={currentImage}
                  src={HeroImages[currentImage]}
                  alt="Grocery basket with vegetables and household items"
                  className="absolute inset-0 object-contain w-full h-full"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ duration: 1 }}
                />
              </AnimatePresence>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;